<template>
  <t-button @click="exportExcel()">{{buttonName}}
  </t-button>
</template>

<script>
  import TButton from '../el/t-button'

  export default {
    components: { TButton },
    props: {
      taskName: {
        type: String,
        required: true
      },
      taskKey: {
        type: String,
        required: true
      },
      fileName: {
        type: String,
        required: true
      },
      buttonName: {
        type: String,
        default: '导出'
      }
    },
    name: 'export-excel',
    data () {
      return {
        loading: false,
      }
    },
    mixins: [tableBase],
    methods: {
      exportExcel () {
        this.$emit('action')
      },
      doExport (data) {
        let param = JSON.stringify(data)
        this.simplePost(Api.report + 'addReport', {
          taskName: this.taskName,
          taskKey: this.taskKey,
          fileName: this.fileName,
          taskParam: param
        }, () => {
          this.msgAlert('已加入导出任务,请前往导出列表查看导出结果')
        })
      }
    },
    mounted () {

    }
  }
</script>


<style lang="less" scoped>

</style>
